import React from 'react';
import { Phone, Instagram } from 'lucide-react';
import { businessInfo, footerLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-securelec-dark relative overflow-hidden">
      {/* Top Border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-securelec-red to-transparent" />

      {/* Main Footer Content */}
      <div className="container mx-auto px-6 pt-16 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h4 className="text-white font-bold mb-6 text-lg">About</h4>
            <p className="text-white/60 mb-6 leading-relaxed text-sm">
              {businessInfo.tagline}
            </p>
            {/* Licenses */}
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-white/40 text-sm">
                <span>Electrical:</span>
                <span className="text-securelec-red font-medium">{businessInfo.licenses.electrical}</span>
              </div>
              <div className="flex items-center gap-2 text-white/40 text-sm">
                <span>Security:</span>
                <span className="text-securelec-red font-medium">{businessInfo.licenses.security}</span>
              </div>
            </div>
          </div>

          {/* Trusted Across Bayside */}
          <div className="lg:col-span-1">
            <h4 className="text-white font-bold mb-6 text-lg">Trusted Across Bayside</h4>
            <p className="text-white/60 text-sm leading-relaxed">
              Securelec proudly supports clients across Carrum and surrounding Bayside suburbs including Chelsea, Patterson Lakes, Seaford, Bonbeach, Frankston and the wider South East Melbourne region.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-securelec-red transition-colors duration-300 text-sm inline-flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-securelec-red/50 rounded-full group-hover:bg-securelec-red transition-colors"></span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Get In Touch</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${businessInfo.phone.mick}`}
                  className="flex items-center gap-3 text-white/60 hover:text-securelec-red transition-colors duration-300 group"
                >
                  <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-securelec-red/20 transition-colors">
                    <Phone className="w-4 h-4 text-securelec-red" />
                  </div>
                  <div>
                    <span className="text-white/40 text-xs block">Mick</span>
                    <span className="text-sm font-medium">{businessInfo.phone.mick}</span>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${businessInfo.phone.tom}`}
                  className="flex items-center gap-3 text-white/60 hover:text-securelec-red transition-colors duration-300 group"
                >
                  <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-securelec-red/20 transition-colors">
                    <Phone className="w-4 h-4 text-securelec-red" />
                  </div>
                  <div>
                    <span className="text-white/40 text-xs block">Tom</span>
                    <span className="text-sm font-medium">{businessInfo.phone.tom}</span>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href={businessInfo.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/60 hover:text-securelec-red transition-colors duration-300 group"
                >
                  <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-securelec-red/20 transition-colors">
                    <Instagram className="w-4 h-4 text-securelec-red" />
                  </div>
                  <span className="text-sm font-medium">{businessInfo.instagram}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Large Logo Section - blends naturally */}
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-center py-4 overflow-hidden">
          <img 
            src="https://customer-assets.emergentagent.com/job_d0850d40-f350-4ecf-87ac-4e2d9723d534/artifacts/lep8nmrg_Logo%201-04.png"
            alt="Securelec electrician and security services Carrum Bayside Melbourne"
            className="w-full max-w-4xl h-auto opacity-15 hover:opacity-25 transition-opacity duration-500"
          />
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/20">
        <div className="container mx-auto px-6 py-5">
          <p className="text-white/40 text-sm text-center">
            © {new Date().getFullYear()} Securelec Services. All Rights Reserved | Website by <a href="https://spaceshipmedia.com.au/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Spaceship Media</a>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
